export function getComponentId(key) {
  return `__impage-component-wrapper-${key}`;
}

export function getHotAreaId(key) {
  return `__impage-hotarea-wrapper-${key}`;
}

export function withPersistReactEvent(handler) {
  return (e) => {
    e.persist();
    return handler(e);
  };
}
